var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 48,
    viewBox: "0 0 155 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2291 24.5605H37.5612V28.8945H46.2291V24.5605Z",
    fill: "url(#paint0_radial_2625_16232)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2291 20.2266H37.5612V23.1159H46.2291V20.2266Z",
    fill: "url(#paint1_radial_2625_16232)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7787 28.8945H14.4467V24.5606H5.7787V28.8945Z",
    fill: "url(#paint2_radial_2625_16232)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7787 23.1152H14.4467V20.2259H5.7787V23.1152Z",
    fill: "url(#paint3_radial_2625_16232)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8952 14.9488V33.2808L29.4905 40.437V23.7863H36.5486V18.2691H15.4593V23.7863H22.5527V40.4511L10.1127 33.2808V14.9488L26.0039 5.7793L41.8952 14.9488Z",
    fill: "url(#paint4_radial_2625_16232)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8609 15.2949V18.2289H60.617V32.449H57.305V18.2485H52.1006V15.3145L65.8609 15.2949Z",
    fill: "#1D1D1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2705 32.694C68.7158 32.7415 68.1572 32.6749 67.6297 32.4982C67.1022 32.3215 66.6171 32.0385 66.205 31.6671C65.4705 30.7608 65.1174 29.608 65.2193 28.4495C65.1582 27.8675 65.2321 27.2794 65.4354 26.7301C65.6387 26.1809 65.966 25.6851 66.3923 25.2808C67.5969 24.5287 69.0153 24.1855 70.4336 24.3028C70.9659 24.3028 71.508 24.3028 72.06 24.381C72.5408 24.4253 73.0182 24.5005 73.4893 24.6059V23.5008C73.5157 23.2078 73.4693 22.9128 73.3542 22.6417C73.239 22.3706 73.0587 22.1317 72.8289 21.9458C72.2036 21.563 71.4715 21.3883 70.7392 21.447C69.8718 21.447 69.103 21.4764 68.4327 21.535C67.7897 21.583 67.1508 21.6745 66.5204 21.8089V19.1487C67.271 18.9809 68.0315 18.86 68.7974 18.7869C69.78 18.6917 70.7672 18.6492 71.7545 18.6597C73.1022 18.5587 74.439 18.9636 75.5001 19.7942C75.938 20.2421 76.2751 20.777 76.4892 21.3637C76.7032 21.9504 76.7894 22.5755 76.7421 23.1976V32.4495H73.785L73.647 31.2465H73.5484C72.9286 31.6949 72.244 32.0477 71.5179 32.293C70.797 32.5519 70.0371 32.6875 69.2705 32.694V32.694ZM70.8181 26.6206C70.1198 26.5649 69.4186 26.6825 68.7777 26.9629C68.5792 27.113 68.4238 27.3121 68.327 27.5403C68.2302 27.7685 68.1952 28.0179 68.2257 28.2636C68.203 28.503 68.2316 28.7444 68.3098 28.972C68.3879 29.1996 68.5138 29.4081 68.6791 29.5839C69.1358 29.8925 69.6862 30.0343 70.2365 29.9849C70.8095 29.9799 71.3794 29.901 71.9319 29.7502C72.473 29.6177 72.9959 29.4207 73.4893 29.1634V26.8358C73.0556 26.7673 72.612 26.7086 72.1882 26.6793C71.7643 26.65 71.301 26.6206 70.8181 26.6206V26.6206Z",
    fill: "#1D1D1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3424 25.4177L90.6991 32.4495H87.1506L84.3414 27.6084L81.5519 32.4495H78.2794L82.6165 25.4177L78.378 18.9336H82.1236L84.6076 23.3346L87.2196 18.9336H90.5611L86.3424 25.4177Z",
    fill: "#1D1D1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3546 29.6034C100.165 29.5946 100.974 29.5128 101.77 29.3589C102.558 29.2141 103.33 28.9947 104.076 28.7037V31.6376C103.197 31.996 102.286 32.2742 101.356 32.4689C100.534 32.6278 99.6988 32.7064 98.8618 32.7037C96.1215 32.7037 94.2093 32.0191 93.125 30.6694C92.0408 29.3198 91.4987 27.0313 91.4987 23.8235C91.4987 20.6156 92.1394 18.5423 93.47 17.134C94.8007 15.7257 96.8214 15.0117 99.67 15.0117C100.518 15.0117 101.277 15.0117 101.937 15.0606C102.535 15.0946 103.13 15.1599 103.721 15.2562V18.1315C103.031 18.0728 102.351 18.0337 101.75 18.0044C101.149 17.975 100.419 18.0044 99.7193 18.0044C97.8662 18.0044 96.6144 18.4347 95.954 19.2856C95.2936 20.1364 94.9683 21.6719 94.9683 23.8626C94.9683 26.0533 95.264 27.5594 95.8653 28.3907C96.4665 29.222 97.5705 29.6034 99.3546 29.6034Z",
    fill: "#1D1D1B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.369 32.4491H106.165V18.9332H109.122L109.26 20.0286H109.349C109.997 19.6221 110.692 19.2938 111.419 19.0506C112.077 18.834 112.766 18.7217 113.459 18.718H113.824C113.876 18.706 113.93 18.706 113.982 18.718V21.7792C113.841 21.7366 113.695 21.7136 113.548 21.7107H112.661C112.059 21.7032 111.457 21.7589 110.867 21.877C110.355 21.9728 109.855 22.1271 109.379 22.3366L109.369 32.4491Z",
    fill: "#1D1D1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 34.1121C118.031 34.1517 118.562 34.0251 119.018 33.7502C119.445 33.3275 119.74 32.7907 119.865 32.205L114.523 18.9336H118.101L121.492 29.0852L124.725 18.9336H128.165L122.96 33.0461C122.608 34.1756 121.954 35.1894 121.068 35.98C120.215 36.6046 119.169 36.9158 118.111 36.8602C117.746 36.8602 117.371 36.8602 116.977 36.8016C116.646 36.7752 116.317 36.7294 115.992 36.6646V34.0338C116.163 34.0743 116.338 34.0972 116.514 34.1023L117.5 34.1121Z",
    fill: "#1D1D1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.025 36.6063H129.822V18.934H132.611L132.798 20.1662H132.936C133.464 19.6611 134.096 19.2771 134.79 19.0416C135.569 18.776 136.39 18.6469 137.214 18.6601C137.956 18.5844 138.704 18.6931 139.393 18.9766C140.081 19.26 140.688 19.7093 141.157 20.2836C141.946 21.3692 142.33 23.2176 142.33 25.6626C142.33 28.1076 141.847 29.9364 140.871 31.0416C139.895 32.1467 138.299 32.6944 136.071 32.6944C135.5 32.6999 134.929 32.6574 134.366 32.5672C133.914 32.5041 133.47 32.3892 133.045 32.2249L133.025 36.6063ZM139.117 25.6626C139.217 24.5378 139.002 23.4072 138.496 22.3961C138.197 22.0634 137.821 21.8083 137.4 21.6532C136.979 21.498 136.526 21.4475 136.081 21.5061C135.533 21.5017 134.987 21.5641 134.454 21.6919C133.957 21.8138 133.476 21.9978 133.025 22.2396V29.3007C133.391 29.457 133.775 29.5687 134.169 29.6332C134.654 29.7075 135.146 29.7435 135.637 29.7408C137.057 29.7408 137.993 29.4572 138.437 28.9095C138.995 27.9225 139.232 26.7886 139.117 25.6626V25.6626Z",
    fill: "#1D1D1B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 130.322,
    y: 4.51172,
    width: 24,
    height: 10,
    rx: 2.5,
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.961 12.5117V6.69354H136.091C136.504 6.69354 136.846 6.76172 137.117 6.89808C137.388 7.03255 137.59 7.21532 137.725 7.44638C137.859 7.67554 137.927 7.93407 137.927 8.22195C137.927 8.46437 137.882 8.66892 137.793 8.83558C137.704 9.00035 137.585 9.13293 137.435 9.23331C137.287 9.33179 137.125 9.40376 136.947 9.44922V9.50604C137.14 9.51551 137.328 9.57801 137.512 9.69354C137.697 9.80717 137.851 9.96911 137.972 10.1793C138.093 10.3896 138.154 10.6452 138.154 10.9464C138.154 11.2437 138.084 11.5108 137.944 11.7475C137.805 11.9824 137.591 12.1689 137.302 12.3072C137.012 12.4435 136.642 12.5117 136.191 12.5117H133.961ZM134.839 11.7589H136.106C136.526 11.7589 136.827 11.6774 137.009 11.5146C137.191 11.3517 137.282 11.1481 137.282 10.9038C137.282 10.7201 137.235 10.5515 137.143 10.3981C137.05 10.2447 136.917 10.1225 136.745 10.0316C136.574 9.9407 136.372 9.89524 136.137 9.89524H134.839V11.7589ZM134.839 9.21058H136.015C136.212 9.21058 136.389 9.1727 136.546 9.09695C136.705 9.02119 136.831 8.91513 136.924 8.77876C137.019 8.64051 137.066 8.47763 137.066 8.29013C137.066 8.0496 136.982 7.84789 136.813 7.68501C136.644 7.52214 136.386 7.4407 136.037 7.4407H134.839V9.21058ZM141.008 12.5998C140.578 12.5998 140.207 12.5079 139.897 12.3242C139.588 12.1386 139.349 11.8782 139.181 11.543C139.014 11.2058 138.931 10.811 138.931 10.3583C138.931 9.91134 139.014 9.5174 139.181 9.17649C139.349 8.83558 139.584 8.56948 139.885 8.3782C140.188 8.18691 140.543 8.09126 140.948 8.09126C141.194 8.09126 141.433 8.13198 141.664 8.21342C141.895 8.29486 142.102 8.4227 142.286 8.59695C142.47 8.77119 142.615 8.99751 142.721 9.27592C142.827 9.55244 142.88 9.88861 142.88 10.2844V10.5856H139.411V9.94922H142.047C142.047 9.72573 142.002 9.52782 141.911 9.35547C141.82 9.18123 141.692 9.04392 141.527 8.94354C141.365 8.84316 141.173 8.79297 140.954 8.79297C140.715 8.79297 140.507 8.85168 140.329 8.96911C140.152 9.08464 140.016 9.23615 139.92 9.42365C139.825 9.60926 139.777 9.81096 139.777 10.0288V10.5259C139.777 10.8176 139.829 11.0657 139.931 11.2702C140.035 11.4748 140.18 11.631 140.366 11.739C140.551 11.8451 140.768 11.8981 141.016 11.8981C141.177 11.8981 141.324 11.8754 141.456 11.8299C141.589 11.7826 141.704 11.7125 141.8 11.6197C141.897 11.5269 141.971 11.4123 142.022 11.2759L142.826 11.4208C142.761 11.6576 142.646 11.8649 142.479 12.043C142.314 12.2191 142.107 12.3564 141.857 12.4549C141.609 12.5515 141.326 12.5998 141.008 12.5998ZM145.859 8.14808V8.8299H143.476V8.14808H145.859ZM144.115 7.10263H144.964V11.2305C144.964 11.3952 144.989 11.5193 145.038 11.6026C145.087 11.6841 145.151 11.7399 145.228 11.7702C145.308 11.7987 145.394 11.8129 145.487 11.8129C145.555 11.8129 145.615 11.8081 145.666 11.7987C145.717 11.7892 145.757 11.7816 145.785 11.7759L145.939 12.4776C145.889 12.4966 145.819 12.5155 145.728 12.5344C145.638 12.5553 145.524 12.5666 145.388 12.5685C145.164 12.5723 144.956 12.5326 144.763 12.4492C144.569 12.3659 144.413 12.2371 144.294 12.0629C144.175 11.8886 144.115 11.6699 144.115 11.4066V7.10263ZM148.069 12.6083C147.792 12.6083 147.542 12.5572 147.319 12.4549C147.095 12.3507 146.918 12.2002 146.787 12.0032C146.659 11.8062 146.594 11.5647 146.594 11.2788C146.594 11.0326 146.642 10.8299 146.736 10.6708C146.831 10.5117 146.959 10.3858 147.12 10.293C147.281 10.2002 147.461 10.1301 147.66 10.0827C147.858 10.0354 148.061 9.99941 148.268 9.97479C148.529 9.94448 148.741 9.91986 148.904 9.90092C149.067 9.88009 149.185 9.84695 149.259 9.80149C149.333 9.75604 149.37 9.68217 149.37 9.5799V9.56001C149.37 9.31191 149.3 9.11967 149.16 8.98331C149.021 8.84695 148.815 8.77876 148.54 8.77876C148.254 8.77876 148.029 8.84221 147.864 8.96911C147.701 9.09411 147.589 9.23331 147.526 9.38672L146.728 9.2049C146.822 8.93975 146.961 8.72573 147.143 8.56286C147.326 8.39808 147.537 8.27876 147.776 8.2049C148.015 8.12914 148.266 8.09126 148.529 8.09126C148.703 8.09126 148.888 8.1121 149.083 8.15376C149.28 8.19354 149.464 8.2674 149.634 8.37535C149.806 8.48331 149.947 8.63767 150.057 8.83842C150.167 9.03729 150.222 9.29581 150.222 9.61399V12.5117H149.393V11.9151H149.358C149.304 12.025 149.221 12.1329 149.111 12.239C149.001 12.3451 148.86 12.4331 148.688 12.5032C148.516 12.5733 148.309 12.6083 148.069 12.6083ZM148.253 11.9265C148.488 11.9265 148.689 11.8801 148.856 11.7873C149.024 11.6945 149.152 11.5733 149.239 11.4237C149.328 11.2721 149.373 11.1102 149.373 10.9379V10.3754C149.342 10.4057 149.284 10.4341 149.197 10.4606C149.111 10.4852 149.014 10.507 148.904 10.5259C148.794 10.543 148.687 10.5591 148.583 10.5742C148.479 10.5875 148.392 10.5988 148.322 10.6083C148.157 10.6291 148.006 10.6642 147.87 10.7134C147.735 10.7627 147.627 10.8337 147.546 10.9265C147.466 11.0174 147.427 11.1386 147.427 11.2901C147.427 11.5004 147.504 11.6594 147.66 11.7674C147.815 11.8735 148.013 11.9265 148.253 11.9265Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2625_16232",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4124 23.1094) scale(10.9552 14.4141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2625_16232",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4124 23.3301) scale(10.9552 9.60942)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2625_16232",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0198 23.7132) scale(22.8357 30.0457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2625_16232",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0198 23.7321) scale(22.8357 20.0305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2625_16232",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0039 23.1152) scale(16.6409 16.6224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0069AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0069AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#004382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#00346D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E65"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaLogo);
export default __webpack_public_path__ + "static/media/betaLogo.77a854cf60eb7b0258e4823cd9f2550b.svg";
export { ForwardRef as ReactComponent };